// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2veNY","dragIcon":"Choice_dragIcon__c9JyN","left":"Choice_left__3zozU","input":"Choice_input__1hHu9"};